import lodash from 'lodash';

export const LOAD_ALL_TASKS = 'LOAD_ALL_TASKS';
export const SORT_TASKS = 'SORT_TASKS';
export const SET_TASK_SORTING_OPTIONS = 'SET_TASK_SORTING_OPTIONS';
export const LOAD_ALL_TASKS2 = 'LOAD_ALL_TASKS';
export const TASKS_LOADING = 'TASKS_LOADING';
export const GET_PENDING_EVENT_TASKS = 'GET_PENDING_EVENT_TASKS';
export const GET_COMPLETED_EVENT_TASKS = 'GET_COMPLETED_EVENT_TASKS';
export const GETTING_PENDING_EVENT_TASKS = 'GETTING_PENDING_EVENT_TASKS';
export const GETTING_COMPLETED_EVENT_TASKS = 'GETTING_COMPLETED_EVENT_TASKS';
export const GET_PENDING_DOA_TASKS = 'GET_PENDING_DOA_TASKS';
export const GET_COMPLETED_DOA_TASKS = 'GET_COMPLETED_DOA_TASKS';
export const GETTING_PENDING_DOA_TASKS = 'GETTING_PENDING_DOA_TASKS';
export const GETTING_COMPLETED_DOA_TASKS = 'GETTING_COMPLETED_DOA_TASKS';
export const CLEAR_BINDER_TASKS = 'CLEAR_BINDER_TASKS';
export const GET_ALL_TASKS = 'GET_ALL_TASKS';

import { queryGraphQL } from 'common/util/query';
import { addApplicationMessages, addApplicationMessage } from 'common/actions/applicationMessagesActions';
import { node, nodeWithArgs, toQuery } from 'common/util/queryHelper';

export function getBinderTaskDetails() {
    return async (dispatch, getState) => {
        const storeState = getState();
        const binderId = lodash.get(storeState, 'binder.id');

        dispatch(loadTasksByBinderId(binderId));
        dispatch(getPendingBinderEventSignatures());
        dispatch(getCompleteBinderEventSignatures());
        dispatch(getPendingBinderDOASignatures());
        dispatch(getCompleteBinderDOASignatures());
    };
}

export function gettingPendingBinderEventSignatures(status){
    return async( dispatch) => {
        dispatch({
            type: GETTING_PENDING_EVENT_TASKS,
            payload: status,
        });
    };
}

export function gettingCompletedBinderEventSignatures(status){
    return async( dispatch) => {
        dispatch({
            type: GETTING_COMPLETED_EVENT_TASKS,
            payload: status,
        });
    };
}

export function gettingPendingBinderDOASignatures(status){
    return async( dispatch) => {
        dispatch({
            type: GETTING_PENDING_DOA_TASKS,
            payload: status,
        });
    };
}

export function gettingCompletedBinderDOASignatures(status){
    return async( dispatch) => {
        dispatch({
            type: GETTING_COMPLETED_DOA_TASKS,
            payload: status,
        });
    };
}

export function getPendingBinderEventSignatures(){
    return async ( dispatch, getState ) => {
        const storeState = getState();
        const binderId = lodash.get(storeState, 'binder.id');
        const query = nodeWithArgs('binder', {
            id : binderId
        }, [
            'id',
            node('pendingEventSignatures', [
                'id',
                'status',
                node('requestedFrom', [
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
                node('createdBy', [
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
                node('event', [
                    'id',
                    'eventType',
                ]),
                'sentDate',
                'binderName',
            ])
        ]);
        dispatch(gettingPendingBinderEventSignatures(true));
        const response = await queryGraphQL(toQuery(query));
        if(response.errors) {
            dispatch(addApplicationMessage('error', 'Failed to load studies. Please try again'));
        } else {
            dispatch({
                type: GET_PENDING_EVENT_TASKS,
                payload: response.data.binder.pendingEventSignatures
            });
            dispatch(gettingPendingBinderEventSignatures(false));
        }
    };
}

export function getCompleteBinderEventSignatures(){
    return async ( dispatch, getState ) => {
        const storeState = getState();
        const binderId = lodash.get(storeState, 'binder.id');
        dispatch(gettingCompletedBinderEventSignatures(true));
        const query = nodeWithArgs('binder', {
            id : binderId
        }, [
            'id',
            node('completeEventSignatures', [
                'id',
                'status',
                node('requestedFrom', [
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
                node('createdBy', [
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
                node('event', [
                    'id',
                    'eventType',
                ]),
                'sentDate',
                'signedDate',
                'binderName',
            ])
        ]);
        const response = await queryGraphQL(toQuery(query));
        if(response.errors) {
            dispatch(addApplicationMessage('error', 'Failed to load studies. Please try again'));
        } else {
            dispatch({
                type: GET_COMPLETED_EVENT_TASKS,
                payload: response.data.binder.completeEventSignatures,
            });
            dispatch(gettingCompletedBinderEventSignatures(false));
        }
    };
}

export function loadTasksByBinderId(binderId){
    const workflowsByProcess = nodeWithArgs('workflowsByProcessVariable', {
        processVariableName : 'binderId',
        processVariableValue : binderId,
    }, [
        'id',
        'title',
        'author',
        'authorDisplayName',
        'actionName',
        'sentDate',
        'endDate',
        'status',
        'documentId',
        'totalInstances',
        'activeInstances',
        'completedInstances',
        node('recipients', [
            'displayName',
            'id',
            'sub',
        ]),
        node('tasks', [
            'finished',
            'deleted',
            'assignee',
            'taskDefinitionKey',
            'name',
        ]),
        node('document', [
            'name',
            'id',
            node('documentType', [
                'displayName',
                'id'
            ])
        ])
    ]);
    return async dispatch => {
        dispatch(queryingTask(true));
        const results = await queryGraphQL(toQuery(workflowsByProcess));
        if(results.errors) {
            dispatch(addApplicationMessages('error', results.formattedErrors));
        }else{
            dispatch({
                type : LOAD_ALL_TASKS,
                payload : results.data.workflowsByProcessVariable
            });
        }
        dispatch(queryingTask(false));
    };
}

export function sortTasks(tasks, sort, by, subpath, format) {
    let sortBy = (by == -1 || lodash.isNil(by))   ? 'desc' : 'asc';
    let orderedTasks = [];
    if(format == 'string'){
        orderedTasks= lodash.orderBy(tasks, [item => lodash.get(item, sort).toLowerCase()], sortBy);
    }else{
        orderedTasks= lodash.orderBy(tasks, sort, sortBy);
    }

    return {
        type: SORT_TASKS,
        payload: {
            orderedTasks : orderedTasks,
            subpath : subpath}
    };
}
export function queryingTask(isLoading) {
    return {
        type : TASKS_LOADING,
        payload : isLoading
    };
}

export function clearBinderTasks(){
    return {
        type: CLEAR_BINDER_TASKS
    };
}

export function setTaskSortingOptions(query, subpath, pathChange) {
    let sortOption = {};

    if (lodash.isEmpty(query) || pathChange) {
        if (subpath === 'completed') {
            sortOption = _defaultSortingOption.completed;
        } else if (subpath === 'pending' || subpath === '') {
            sortOption = _defaultSortingOption.pending;
        }
    } else {
        sortOption.s = query.s;
        sortOption.o = query.o;
        sortOption.f = query.f;
    }
    return {
        type: SET_TASK_SORTING_OPTIONS,
        payload: sortOption
    };
}

const _defaultSortingOption = {
    completed: {
        s: 'endDate',
        o: -1,
        f: 'date'
    },
    pending: {
        s: 'daysSinceAssigned',
        o: -1,
        f: 'integer'
    }
};

export function getPendingBinderDOASignatures(){
    return async ( dispatch, getState ) => {
        const storeState = getState();
        const binderId = lodash.get(storeState, 'binder.id');
        const query = nodeWithArgs('binder', {
            id : binderId
        }, [
            'id',
            node('pendingDOASignatures', [
                'id',
                'status',
                node('requestedFrom', [
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
                node('createdBy', [
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
                node('delegation', [
                    'id',
                    node('user', [
                        'id',
                        'displayName',
                        'emailAddress',
                    ]),
                    node('rolesManagement', [
                        'id',
                        'name'
                    ]),
                    'taskIds',
                    'startDate',
                    'endDate',
                ]),
                'sentDate',
                'binderName',
            ])
        ]);
        dispatch(gettingPendingBinderDOASignatures(true));
        const response = await queryGraphQL(toQuery(query));
        if(response.errors) {
            dispatch(addApplicationMessage('error', 'Failed to load studies. Please try again'));
        } else {
            dispatch({
                type: GET_PENDING_DOA_TASKS,
                payload: response.data.binder.pendingDOASignatures
            });
            dispatch(gettingPendingBinderDOASignatures(false));
        }
    };
}

export function getCompleteBinderDOASignatures(){
    return async ( dispatch, getState ) => {
        const storeState = getState();
        const binderId = lodash.get(storeState, 'binder.id');
        dispatch(gettingCompletedBinderDOASignatures(true));
        const query = nodeWithArgs('binder', {
            id : binderId
        }, [
            'id',
            node('completeDOASignatures', [
                'id',
                'status',
                node('requestedFrom', [
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
                node('createdBy', [
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
                node('delegation', [
                    'id',
                    node('user', [
                        'id',
                        'displayName',
                        'emailAddress',
                    ]),
                    node('rolesManagement', [
                        'id',
                        'name'
                    ]),
                    'taskIds',
                    'startDate',
                    'endDate',
                ]),
                'sentDate',
                'signedDate',
                'binderName',
            ])
        ]);
        const response = await queryGraphQL(toQuery(query));
        if(response.errors) {
            dispatch(addApplicationMessage('error', 'Failed to load studies. Please try again'));
        } else {
            dispatch({
                type: GET_COMPLETED_DOA_TASKS,
                payload: response.data.binder.completeDOASignatures,
            });
            dispatch(gettingCompletedBinderDOASignatures(false));
        }
    };
}
